import { c as _c } from "react/compiler-runtime";
import { Users } from '@repo/ui/icons';
import type { CmdkUser } from './_hooks/use-cmdk-users.ts';
export const getCmdkUserTitle = (user: CmdkUser) => [user.name, user.last_name].filter(Boolean).join(' ') || user.email;
export const UserResultRow = t0 => {
  const $ = _c(10);
  const {
    user
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Users className="size-4 shrink-0 text-muted-foreground" data-sentry-element="Users" data-sentry-source-file="user-result-row.tsx" />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== user) {
    t2 = getCmdkUserTitle(user);
    $[1] = user;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <span className="truncate font-medium">{t2}</span>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== user.email) {
    t4 = <span className="truncate text-xs text-muted-foreground">{user.email}</span>;
    $[5] = user.email;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <>{t1}<span className="flex min-w-0 flex-1 flex-col">{t3}{t4}</span></>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};